import React from "react";
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Typography} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {useTranslation} from "react-i18next";
import PremiumDialogPng from "../../assets/premium-template.png";
import {PrimaryBigButton} from "../../components/buttons/mainButton";
import {sendEmailContact} from "../../services/EmailContactService";

const CLIENT_APPOINTMENT = "https://bookings.cloud.microsoft/book/AGENCELIBERTYRDVCLIENTS@tradeunion91.onmicrosoft.com/?ismsaljsauthenabled";

type BlockedTemplateCreationDialogProps = {
  open: boolean,
  close: () => void
}

export default function BlockedTemplateCreationDialog({open, close}: BlockedTemplateCreationDialogProps): JSX.Element {
  const {t} = useTranslation();

  return (
    <Dialog open={open} onClose={close} sx={{"& .MuiDialog-container": {height: "100%", "& .MuiDialog-paper": {maxWidth: "562px"}}}}>
      <DialogTitle sx={{display: "flex", justifyContent: "flex-end", backgroundColor: "premium.x_light", pt: 5, pr: 5, pb: "0px"}}>
        <IconButton sx={{p: "0px"}} onClick={close}><ClearIcon sx={{color: "neutral.main"}} /></IconButton>
      </DialogTitle>
      <DialogContent sx={{p: "0px"}}>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "premium.x_light", px: 5, pb: 8}}>
          <img src={PremiumDialogPng} alt="" style={{width: 90, height: "auto"}} />
          <Typography variant="h1" sx={{fontWeight: "bold", textAlign: "center", mt: 2, color: "neutral.dark"}}>
            {t("email_templates.blocked_creation.title")}
          </Typography>
        </Box>
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", p: 5, pb: 6}}>
          <Typography variant="body2" color="neutral.dark" sx={{mb: 2, textAlign: "center", "& b": {fontWeight: "bold"}}}
            dangerouslySetInnerHTML={{__html: t("email_templates.blocked_creation.content")}} />
          <div
            onClick={(): void => {
              sendEmailContact({askContact: true});
              window.open(CLIENT_APPOINTMENT, "_blank");
            }}
            style={{width: "100%", display: "flex", justifyContent: "center"}}
          >
            <PrimaryBigButton label={t("email_templates.blocked_creation.button_label")} sx={{mt: 2, backgroundColor: "premium.main", color: "neutral.dark", fontWeight: "700"}} />
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
